/**
 * The portal's two sections, addressable from outside: `/account?section=account`
 * opens on the parent's own details, so support replies and emails can link
 * straight to them — the same idea as the checkout's `?plan=` links. The kids
 * are the first tab and what a parent comes for, so they are the default and
 * never need naming.
 */
export type Section = 'family' | 'account'

export const SECTION_PARAM = 'section'

const DEFAULT_SECTION: Section = 'family'

function isSection(value: string | null): value is Section {
  return value === 'family' || value === 'account'
}

/** The section a link asked for; anything unknown opens at the top, on the kids. */
export function readSection(search: string): Section {
  const value = new URLSearchParams(search).get(SECTION_PARAM)
  return isSection(value) ? value : DEFAULT_SECTION
}

/**
 * Put the section in the address bar without navigating, so a reload or a
 * copied link lands on the same view. The default is written as an absence,
 * keeping the plain `/account` address clean.
 */
export function writeSection(section: Section): void {
  const url = new URL(window.location.href)
  if (section === DEFAULT_SECTION) url.searchParams.delete(SECTION_PARAM)
  else url.searchParams.set(SECTION_PARAM, section)
  window.history.replaceState(window.history.state, '', url)
}
